import { Link } from 'react-router-dom';
import carpet from '../../assets/images/carpet.jpg';
import "../../assets/css/ModernCarpe.css"

function ModerCarpet() {
    return (
            <div className="ModernCarpe-section" style={{ background:"#dec7a885" }}>
                <div className="container">
                        <div className="row"> 
                            <div className="col-12 col-sm-6 col-md-6 padding-right001">
                                <div className="pagecontent"> 
                                      <div style={{ textAlign: "center", padding: "30px" }}> 
                                           <h4> Timeless Modern Carpet </h4> 
                                           <p> Carpets add warmth, comfort, and style to any space, enhancing the overall look of your home. With a wide range of colors and textures, they create a cozy and inviting atmosphere. </p>
                                           <Link to="/productList" className='btn btn-dark-bg-border'>  View More </Link>
                                      </div> 
                                  </div>
                              </div>
                            <div className="col-12 col-sm-6 col-md-6 padding-left001">
                                <img src={carpet} alt="Modern Carpet"/>
                            </div>
                        </div>
                  </div>
            </div>
    )
}
export default ModerCarpet;
